export default __webpack_public_path__ + "assets/1a609fc4fd84ae366ef60940c9427581.png";